export default "__VITE_ASSET__DqlrtxrT__"